import { z } from 'zod';


const holidayByRegionFormBaseSchema = z.object({
  holidayTypeId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  regionId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  date: z.string().min(1, 'attendance:holiday.validation.dateRequired'),
  reason: z
    .string()
    .min(1, 'attendance:holiday.validation.reasonRequired')
    .max(500, 'attendance:holiday.validation.reasonMaxLength'),
});

export const holidayByRegionFormSchema = holidayByRegionFormBaseSchema
  .refine((data) => data.holidayTypeId !== null, {
    message: 'attendance:holiday.validation.holidayTypeRequired',
    path: ['holidayTypeId'],
  })
  .refine((data) => data.regionId !== null, {
    message: 'attendance:holiday.validation.regionRequired',
    path: ['regionId'],
  });

export type HolidayByRegionFormData = z.infer<typeof holidayByRegionFormSchema>;